import { InferType, object, string } from 'yup'
import moment from 'moment'

const idRegexp = /^([0-9a-fA-F]{24})?$/

export const PastVisitsFiltersSchema = object({
  memberId: string().label('Member ID').matches(idRegexp, 'Invalid Member ID').notRequired().nullable().default(''),
  pendingVisitId: string().label('Visit ID').matches(idRegexp, 'Invalid Visit ID').notRequired().nullable().default(''),
  date: string()
    .label('Date')
    .notRequired()
    .nullable()
    .test('validDate', 'Invalid date', function (date) {
      if (!date) return true

      return moment(date, 'MM-DD-YYYY').isValid()
    })
    .test('maxDate', 'Date cannot be in the future', function (date) {
      if (!date) return true

      const dateObj = moment(date, 'MM-DD-YYYY').startOf('day')

      return dateObj.isBefore(moment().endOf('day'))
    })
    .default(''),
})

export type PastVisitsFiltersValues = InferType<typeof PastVisitsFiltersSchema>
